import { useState } from 'react';
import { useIsomorphicLayoutEffect } from '@fiverr-private/hooks';
import { useEventListener } from './useEventListener';

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
    });

    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };

    useEventListener('resize', handleSize);

    // Set size at the first client-side load
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);

    return windowSize;
}
